'use client';
import wrappers from "components/_styled/wrappers.module.css"
import styles from './DestinationsByPlace.module.css';
import ByTown from "./";

const Properties = (props) => (
  <>
    <div className={wrappers.FluidWrapper}>
      <div className={wrappers.SmoothWrapper}>
        <div className={styles.Intro}>
          <h1>Browse Shops to Let by Town or City</h1>
          <p>
            With thousands of properties across hundreds of locations across the UK, Completely Retail has the largest
            collection of available shops to let, rent or buy. Find your ideal location below using our handy list of
            towns and cities in the UK.
          </p>
        </div>
      </div>
    </div>
    <ByTown {...props} url={(uri) => `/shops-to-rent/${uri}`} />
  </>
);

export default Properties;
